export default "__VITE_ASSET__lq6wWj7F__"